import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { OverlaysQuery } from '@custom/schema';

export const useOverlaysQuery = () => useStaticQuery(graphql(OverlaysQuery));
